function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLastPeriod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.49,47.67S250.25,17.78,172.41,62.78,56.15,198.56,23.08,271.25s-12.58,147.33,47.69,182,100.36-14.81,184.29-16.18,106.67,11.12,175.74-36.24,80.26-161.12,24.25-246.11S330.49,47.67,330.49,47.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.49,47.67S250.25,17.78,172.41,62.78,56.15,198.56,23.08,271.25s-12.58,147.33,47.69,182,100.36-14.81,184.29-16.18,106.67,11.12,175.74-36.24,80.26-161.12,24.25-246.11S330.49,47.67,330.49,47.67Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shapes--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 392.69,
    y: 287.68,
    width: 19.31,
    height: 19.31,
    transform: "translate(-92.41 371.59) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.18,
    y: 46.35,
    width: 19.31,
    height: 19.31,
    transform: "translate(-8.02 92.65) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.05,
    y: 329.55,
    width: 11.94,
    height: 11.94,
    transform: "translate(-212.93 156.98) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.33,
    y: 192.52,
    width: 11.94,
    height: 11.94,
    transform: "translate(-130.01 83.1) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.53,
    y: 94.79,
    width: 11.94,
    height: 11.94,
    transform: "translate(40.2 298.57) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.46,
    y: 339.98,
    width: 16.98,
    height: 16.98,
    transform: "translate(-216.54 174.16) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.43,
    y: 326.14,
    width: 11.94,
    height: 11.94,
    transform: "translate(-134.84 338.68) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.75,
    y: 79.81,
    width: 22.85,
    height: 22.85,
    transform: "translate(54.45 313.93) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.04,
    y: 459.08,
    width: 11.94,
    height: 11.94,
    transform: "translate(-260.6 300.97) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.88,
    cy: 189.63,
    r: 12.27,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420.75,
    cy: 227.8,
    r: 11.59,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 462.33,
    cy: 148.04,
    r: 6.82,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,58.73a4.1,4.1,0,1,0-4.09,4.09A4.09,4.09,0,0,0,326,58.73Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.19,
    cy: 291.89,
    r: 4.09,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.38,
    cy: 401.65,
    r: 6.14,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.93,391.42a5.46,5.46,0,1,0-5.45,5.46A5.45,5.45,0,0,0,428.93,391.42Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.3,39a5.46,5.46,0,1,0-5.46,5.45A5.45,5.45,0,0,0,385.3,39Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 167.14,
    y1: 248.26,
    x2: 128.28,
    y2: 269.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.51,
    y1: 133.04,
    x2: 135.1,
    y2: 149.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.28,
    y1: 40.32,
    x2: 169.87,
    y2: 83.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.95,
    y1: 21.23,
    x2: 232.59,
    y2: 55.32,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 311.67,
    y1: 102.36,
    x2: 346.44,
    y2: 67.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.07,
    y1: 172.58,
    x2: 390.07,
    y2: 162.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.44,
    y1: 248.94,
    x2: 356.66,
    y2: 263.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.42,
    y1: 101.68,
    x2: 154.87,
    y2: 117.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 354.62,
    y1: 131,
    x2: 332.8,
    y2: 141.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.91,
    y1: 205.31,
    x2: 118.73,
    y2: 212.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340.98,
    y1: 214.17,
    x2: 351.89,
    y2: 216.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hand-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.32,173.58c-3.86-2.67-18.38-.3-27.57,7.11s-11.26,10.08-11.26,10.08-4.15-29.05-4.15-29.94-5.93-55.43-7.12-63.43-3-19.86-4.74-22.53-8.89-3-11.26-1.77l-2.37,1.18s1.18-20.75-1.19-25.79-9.78-2.07-11.86.6a29.18,29.18,0,0,0-3.55,6.81s-6.82-2.37-10.67,5.34-6.82,14.52-7.41,21.93-3.86,16.9-3.86,16.9-3.85-6.23-8-2.67-8.89,17.49-10.08,27.57-2.37,36.75-2.37,36.75-2.37,12.15-3.56,21.94-.29,50.39,4.15,67.28,10.38,27.57,10.38,27.57,10.37,34.08,11.85,38.83,17.79,69.36,17.79,69.36L312.08,325s-12.15-33.49-14.82-41.2-4.45-10.08-4.45-10.08,14.82-21,22.83-27.27,12.15-27,14.22-36.16,10.67-21.93,15.42-26.08S354.17,176.25,350.32,173.58ZM240.64,159.35c-.88,0-.59-11.56-.59-25.49s2.37-20.16,2.37-20.16c-1.18,6.23,1.19,37.05,1.19,39.13S241.53,159.35,240.64,159.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.47,278.83c3.71-1.88,4.38-3.88,4.38-3.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.35,272s16.31,10.67,24.31,8.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.49,190.77s-6.23,9.78-7.71,13.34-2.37,6.52-5,8-6.22,3.56-6.22,3.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.58,193.67c-7.54,3.5-18.15,9.68-24.18,18.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.3,190.18s-2.18.67-5.48,2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.14,216.26s-5.34,9.78-7.71,17.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.25,55.9S263.76,68.35,261.69,87s-3.26,27.86-3,39.72S262.28,149,262,150.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.85,74.28a97.37,97.37,0,0,0,0,17.79c.88,10.07-.89,28.75-.89,35.86s.29,17.79.59,21a12.21,12.21,0,0,0,2.07,5.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.48,156.39s1.48,2.66,11.26,3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,149.27s7.11,1.48,11.86.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.16,161.72s0,3-8.59,5.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.06,153.72c.89-.59,4.44-1.78,5.33-5.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.57,199.12s18.43-6.75,30.1-9.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.89,499.14H468.23c-11.13-14.69-51.74-68.22-54.39-70.87-3.07-3.07-16.59-4.91-16.59-4.91l-39.93-33.18-49.76-82.32L260.25,373.6l-8-32L234.45,408s64.51,78.64,67,81.71C301.89,490.3,304.67,493.83,308.89,499.14Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hand-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.12,268.68s-13.19-33.78-16.37-40-20.44-33.23-21.31-40.55-3.57-19.52-6.35-24.62,5.5-8.44,12.34-2,11,17,10.9,20,15.36,14.35,15.36,14.35l2.81-26s3-64.59,2.37-74.23-1.25-30.11,6.4-30.9S199.1,70,199.1,70s.28-15.26,8.78-14.27c6.5.75,9,6.88,9.94,9.82s2.07,6.62,2.07,6.62,5.36-3.64,10.59,5c3,5,9.38,20.64,10.41,24.62s1.35,5.42,1.35,5.42a11.39,11.39,0,0,1,10.35,7.33c3.18,7.57,7.7,27.33,12.07,43.66a133.47,133.47,0,0,1,4.19,31.86s1.71,52.57-1.81,69.29-10.14,31-11.5,32.33-20.91,59.08-20.91,59.08l-67.84-25.15s14.13-34.71,16.36-42.28A35.45,35.45,0,0,0,184.12,268.68Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.92,219.4a19.94,19.94,0,0,0,.86,5.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.61,198.74a32.69,32.69,0,0,0-5.82,12.42,30.2,30.2,0,0,0-.77,4.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.1,70s1.18,21,2,31.3,1.17,26.36,1.24,36.88-1.21,23.73-1.93,26.6a51.23,51.23,0,0,1-2.32,6.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.89,72.15a11.09,11.09,0,0,0-2.24,8.91c1.11,5,6.27,33.06,6.26,37.12s.29,39.35.37,41.74-1.61,10.43-2.41,13.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.24,107.21s-3.82.39-3,6.37,2.76,25.41,2.76,30.82,1.26,17.92,1,29.71S245.51,190,246.79,193",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.24,185.85s-1.36,6.77.47,10.27,4.37,10.92,4.36,15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.94,182.51s-.72,5.58.07,9.16a25,25,0,0,0,3.26,7.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.79,191.29s-.8,5.9.63,9.64a46.13,46.13,0,0,0,3.1,6.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,499.14l63.07-142.31S225.18,334.61,207.48,323s-38.92-11.31-38.92-11.31-27.71,59.05-29.17,62.81-20.78,43.77-20.78,43.77-8.49,3-12.26,9.81c-2.95,5.32-24.23,51.42-33.3,71.11Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.67,
    cy: 361.08,
    r: 5.88,
    transform: "translate(-151.69 167.72) rotate(-30.6)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.48,384.52a5.88,5.88,0,1,1-4.27-7.13A5.87,5.87,0,0,1,227.48,384.52Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastPeriod);
export default __webpack_public_path__ + "static/media/lastPeriod.0ad273372e6c76387f63adff2e3dcc2a.svg";
export { ForwardRef as ReactComponent };